import axios from 'axios'
import appConfig from '@src/app.config'
import store from '../state/store'

const instance = axios.create({
  baseURL: appConfig.apiDomain,
  headers: {
    withCredentials: true,
    Accept: 'application/json',
  },
})

instance.interceptors.response.use(
  function(response) {
    if (
      response.config.method === 'get' ||
      response.config.url.endsWith('refresh')
    )
      return response

    let action
    let subfixReg = /\/.*/
    let prefixReg = /^\/(sms|ip|voip)\//

    switch (response.config.method) {
      case 'put':
      case 'patch':
        action = 'update'
        break
      case 'post':
        action = 'create'
        break
      case 'delete':
        action = 'delete'
        break

      default:
        action = 'view'
    }

    let moduleName = response.config.url
      .replace(appConfig.apiDomain, '')
      .replace(prefixReg, '')
      .replace(subfixReg, '')
    let notification = {
      id: Date.now(),
      type: 'success',
      title: action.toUpperCase(),
      message: '',
    }
    switch (response.status) {
      case 200:
        if (action === 'view') {
          notification = null
          break
        }

        if (action === 'create') {
          notification = null
          break
        }

        notification.message = `The ${moduleName} Successfuly ${action}!`
        break
      case 201:
      case 204:
        notification.message = `The ${moduleName} Successfuly ${action}!`
        break
    }
    if (notification) {
      store.dispatch('notification/addNotification', notification, {
        root: true,
      })
    }

    return response
  },
  function(error) {
    let action = ''
    let subfixReg = /\/.*/
    let prefixReg = /^\/(sms|ip|voip)\//
    let moduleName = error.config.url
      .replace(appConfig.apiDomain, '')
      .replace(prefixReg, '')
      .replace(subfixReg, '')

    switch (error.response.config.method) {
      case 'put':
      case 'patch':
        action = 'update'
        break
      case 'post':
        action = 'create'
        break
      case 'delete':
        action = 'delete'
        break
      default:
        action = 'view'
    }

    let notification = {
      id: Date.now(),
      type: 'error',
      title: action.toUpperCase(),
      message: `Failed to ${error.response.config.method} ${moduleName}. `,
    }

    switch (error.response.status) {
      case 400:
        notification.message = `Invalid data format`
        break
      case 402:
        notification.message = `Not enough balance`
        break
      case 403:
        notification.message = `No permission to ${action} ${moduleName}`
        break
      case 404:
        notification = null
        break
      case 409:
        notification.message +=
          error.response.config.method === 'delete'
            ? `The ${moduleName} is ready in use!`
            : `The ${moduleName} is ready exist`
        break
      default:
        notification.message += 'Please contact our customer support'
    }

    if (notification) {
      store.dispatch('notification/addNotification', notification, {
        root: true,
      })
    }

    return Promise.reject(error)
  }
)

export default instance
